import {
	HttpErrorResponse,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, of, tap, throwError } from 'rxjs';

import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (
	req: HttpRequest<any>,
	next: HttpHandlerFn
) => {
	const toast = inject(ToastService);
	const translate = inject(TranslateService);

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			var isFromLogin =
				error.status === 401 && error.url?.contains('accessToken');
			if ((error.status !== 401 && error.status !== 403) || isFromLogin) {
				let errorMessage = isFromLogin
					? translate.instant('SNACKBAR.LOGIN_MSGERROR')
					: translate.instant('SNACKBAR.MSGERROR');
				if (
					error instanceof HttpErrorResponse &&
					error.error instanceof Blob &&
					error.error.type === 'application/json'
				) {
					return new Promise<any>((resolve, reject) => {
						let reader = new FileReader();
						reader.onload = (e: Event) => {
							try {
								const msg = JSON.parse((<any>e.target).result).message;
								toast.error(msg);
								reject(error);
							} catch (e) {
								toast.error(errorMessage);
								reject(error);
							}
						};
						reader.onerror = e => reject(error);
						reader.readAsText(error.error);
					});
				} else {
					if (error && error.error && error.error.error_description)
						errorMessage = error.error.error_description;

					if (error && error.error && error.error.message)
						errorMessage = error.error.message;

					toast.error(errorMessage);
					return throwError(() => error);
				}
			}

			return of();
		})
	);
};
